// extracted by mini-css-extract-plugin
export var List = "List-module--List--srdgk";
export var unstyled = "List-module--unstyled--Ms3aK";